<template>
  <div class="course-videos-wrap">
    <div class="title flex-align-center">
      <i class="icon-video"></i>
      <span class="f20 f-bold color-2 ml10">视频教程</span>
    </div>
    <div class="videos-list-wrap">
      <div class="videos-list-cell" v-for="(item, index) in baseList" :key="index">
        <div
          class="videos-box"
          @click="playVideo(item)" >
          <i class="the-mask"></i>
          <div class="btn-center-wrap">
            <i class="icon-play btn-play"></i>
          </div>
          <img :src="item.posterUrl" />
          <!-- <video
            x5-playsinline="true"
            webkit-playsinline="true" 
            playsinline="true" 
            object-fit="fill"
            controls
            :src="item.url"
            :poster="item.posterUrl">
          </video> -->
        </div>
        <div class="explain-box">
          {{ item.title }}
        </div>
      </div>
    </div>

    <div class="flex-justify-center mt40" v-if="!allList">
      <el-button type="primary" round @click="allList = true">查看更多教程</el-button>
    </div>

    <!-- <el-dialog
      title='视频教程'
      width="100%"
      custom-class="videoPanelDialog"
      :top="'0'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :lock-scroll="false">
        <div class="flex-justify-center" @click="handleClose">
          <video
            @click.stop="deletePreview"
            playsinline="true" 
            object-fit="fill"
            controls
            autoplay
            class="panel-video-dome"
            :src="current.url"
            :poster="current.posterUrl">
          </video>
        </div>
    </el-dialog> -->
    <!-- <video 
      controls 
      autoplay 
      id="videoShowPanel" 
      :src="current.url" 
      :poster="current.posterUrl"
      style="height: 0; width: 0">
    </video> -->
  </div>
</template>

<script>
import { getItem } from '@/utils/storage.js'
import { isLogin } from '@/api/home.js'
import { 
  getTutorialVideos,
  recordVideos,
} from '@/api/course.js'
import { 
  checkIsFullScreen, 
  // requestFullScreen,
} from '@/utils'
export default {
  name: 'courseVideos',
  components: {},
  props: {},
  data() {
    return {
      list: [],
      allList: false,
      dialogVisible: false,
      current: {
        url: '',
        posterUrl: '',
        title: '',
      },
    }
  },
  computed: {
    baseList() {
      const { list, allList } = this
      if (allList) return list
      return list.slice(0, 4)
    },
  },
  watch: {},
  created() {
    this.getTutorialVideos()
  },
  mounted() {
    // this.initVideo()
  },
  methods: {
    deletePreview(){},
    getTutorialVideos() {
      getTutorialVideos().then((res) => {
        if (res.success) {
          this.list = res.data
        }
      })
    },
    havelogged(){
      isLogin().then(res=>{
        console.log(res.data);
      })
    },
    playVideo(item) {
      window.open(item.url, '_blank')
      // this.current = Object.assign(this.current, item)
      // this.dialogVisible = true
      // const marioVideo = document.querySelector('#videoShowPanel')
      // requestFullScreen(marioVideo)
      const { id } = item
      /*
      this.havelogged()
      */
      getItem('userInfo') && id && recordVideos({
        type: 'video',
        id,
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.current.url = ''
    },
    initVideo() {
      function fullscreenchange(event) {
        if (checkIsFullScreen()) {
          //  进入全屏
        } else {
          //  退出全屏
          const { target } = event
          target.src = ''
        }
      }
      const eventListeners = [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
      ]
      eventListeners.forEach((item) => {
        window.addEventListener(item, fullscreenchange)
      })
      this.$once('hook:beforeDestroy', function () {
        eventListeners.forEach((item) => {
          window.removeEventListener(item, fullscreenchange)
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .videoPanelDialog {
  &.el-dialog {
    margin: 0 auto;
  }
  .el-dialog__header {
    padding: 0px 20px;
    height: 44px;
    line-height: 44px;
  }
  .el-dialog__headerbtn {
    top: 10px;
  }
  .el-dialog__body {
    padding: 10px 20px;
    background-color: #F8F8F8;
  }
  .panel-video-dome {
    min-width: 1200px;
    height: calc(100vh - 64px);
  }
}

.videos-list-wrap {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  flex-wrap: wrap;
  margin-right: -28px;
  &:after{
    content: ''; 
    flex: auto
  }
  .videos-list-cell {
    width: 278px;
    margin-right: 28px;
    /* height: 290px; */
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(255, 255, 255, 0.1),
      0px 6px 26px 0px rgba(95, 139, 230, 0.16);
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
    .videos-box {
      /* height: 200px; */
      position: relative;
      font-size: 0;
      cursor: pointer;
      .btn-center-wrap {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }
      .the-mask {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.3);
      }
      &:hover {
        .btn-play {
          transform: scale(1.1);
        }
        .the-mask {
          background-color: rgba(0,0,0,.6);
        }
      }
      img {
        width: 100%;
      }
      video {
        width: 100%;
        height: 100%;
      }
    }
    .explain-box {
      height: 90px;
      padding: 15px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #24232f;
      line-height: 28px;
    }
  }
}
</style>
